/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-webpack-loader-syntax */
export { default } from 'scss-extract-loader?{"plugins":["sass-extract-js"]}!../../assets/stylesheets/design-system/_vars.scss';
